import styles from './FJMobileImageExtenderEdit.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import FJMobileArrow from '../../../assets/svg/mobile-arrow.svg?react';
import UploadIcon from '../../../assets/svg/upload-black.svg?react';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton';
import { useState } from 'react';
import FJFileUpload from '../../../common/components/FJFileUpload/FJFileUpload';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import FJUtil from '../../../util/FJUtil';
import FJImageExtenderData from '../../../config/dataConfig/FJImageExtenderData';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import FJTextToImageDataConfig from '../../../config/dataConfig/FJTextToImageDataConfig';
const FJMobileImageExtenderEdit = props => {
    const {
        onGenerate,
        taskStatus,
        freeNumCreation,
        isProjectLoading,
        uploadImg,
        isFree,
        useCredit,
        curRatioName,
        changeRatio,
        generateNumber,
        handleChangeGenerateNumber,
    } = props;
    const [expandEdit, setExpandEdit] = useState(true);
    const isDisabled = FJUtil.isGeneratingStatus(taskStatus);

    const _renderEditContent = () => {
        return (
            <div
                className={classNames(
                    styles.edit_content,
                    expandEdit ? styles.show : styles.hide,
                    isDisabled && styles.disabled,
                )}
            >
                <div className={styles.edit_title}>{FJLocalStore._('aspect-ratio')}</div>
                <div className={styles.ratio_list_box}>
                    {FJImageExtenderData.RATIO_LIST.map(item => (
                        <FJHoverBoardGradation
                            key={item.name}
                            className={classNames(styles.ratio_item, curRatioName === item.name && styles.active)}
                            contentClassName={styles.ratio_item_content}
                            active={curRatioName === item.name}
                            borderRadius={12}
                            onClick={() => changeRatio(item)}
                            selectBgColor={'#FFF'}
                        >
                            <item.icon />
                            <span className={styles.ratio_item_text}>{FJLocalStore._(item.name)}</span>
                        </FJHoverBoardGradation>
                    ))}
                </div>
                <div className={styles.edit_title}>{FJLocalStore._('quantity')}</div>
                <div className={styles.number_list_box}>
                    {FJTextToImageDataConfig.IMAGE_NUMBER_LIST.map(item => (
                        <FJHoverBoardGradation
                            key={item.value}
                            className={classNames(styles.number_item, generateNumber === item.value && styles.active)}
                            contentClassName={styles.number_item_content}
                            active={generateNumber === item.value}
                            borderRadius={12}
                            onClick={() => handleChangeGenerateNumber(item.value)}
                            selectBgColor={'#FFF'}
                        >
                            <div className={styles.number_item_text}>{item.text}</div>
                        </FJHoverBoardGradation>
                    ))}
                </div>
            </div>
        );
    };
    return (
        <div className={styles.container}>
            <div
                className={styles.edit_header}
                onClick={() => {
                    setExpandEdit(!expandEdit);
                }}
            >
                <div className={styles.title}>{FJLocalStore._('image-settings')}</div>
                <FJMobileArrow className={!expandEdit ? styles.arrow_up : ''} />
            </div>
            {_renderEditContent()}
            <div className={styles.btn_box}>
                <FJFileUpload
                    className={classNames(styles.upload_box, isDisabled && styles.disabled)}
                    onUpload={uploadImg}
                >
                    <UploadIcon />
                </FJFileUpload>
                <FJGenerateButton
                    className={styles.generate_btn}
                    onClick={onGenerate}
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    isFree={isFree}
                    useCredit={useCredit}
                    isProjectLoading={isProjectLoading}
                />
            </div>
        </div>
    );
};

FJMobileImageExtenderEdit.propTypes = {
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    isProjectLoading: PropTypes.bool,
    uploadImg: PropTypes.func,
    isDisabled: PropTypes.bool,
    isFree: PropTypes.bool,
    useCredit: PropTypes.bool,
    curRatioName: PropTypes.string,
    changeRatio: PropTypes.func,
    generateNumber: PropTypes.number,
    handleChangeGenerateNumber: PropTypes.func,
};

export default FJMobileImageExtenderEdit;
